const DEVICE_TIMEFRAME_MODAL = 'DEVICE_TIMEFRAME_MODAL';
export const DEVICE_TIMEFRAME_MODAL_OPEN = `${DEVICE_TIMEFRAME_MODAL}_OPEN`;
export const DEVICE_TIMEFRAME_MODAL_CLOSE = `${DEVICE_TIMEFRAME_MODAL}_CLOSE`;

export const showDeviceTimeframeModal = (
  targetUser,
  device,
  timeframeIndex,
) => ({
  type: DEVICE_TIMEFRAME_MODAL_OPEN,
  payload: {
    device,
    targetUser,
    timeframeIndex,
  },
});

export const hideDeviceTimeframeModal = () => ({
  type: DEVICE_TIMEFRAME_MODAL_CLOSE,
});
